import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
 createCapacityConsumer,
 getAllEnergyTypes,
 getConsumerDetails,
 getConsumerrCapacityall,
 updateCapacityConsumer,
} from "../../../store/ConsumerCapacity/action";
import "../../Capacity/capacity.css";
import "../../DashBoard/previewModel.css";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { addHours } from "date-fns";
// import { disableButton, enableButton } from "../../store/ButtonFlag/actions";
import CustomConfirmBox from "../../DashBoard/customConfirmBox";
import { toastProperties } from "../../../commons/Toast/Toaster";
import capacityConsumerService from "../../../components/Services/capacityConsumer.service";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";
import CustomTimePicker from "../../../components/TimePicker/customTimePicker";

export const ConsumerCapacityModal = ({
 isOpen,
 handleSubmit,
 getMatchingProfilesCon,
 myProfileDetails,
 handleCapacityListing,
}) => {
 const dispatch = useDispatch();
 let isEditCase = typeof isOpen == "object";
 const energyTypes = useSelector(
  (state) => state?.consumerCapacityReducer?.energyTypes || []
 );
 const consumerDetails = useSelector(
  (state) => state?.consumerCapacityReducer?.consumerDetails || []
 );
 const allConCapacity = useSelector(
  (state) => state?.consumerCapacityReducer?.allConCapacity || []
 );
 const isButtonEnabled = useSelector(
  (state) => state?.buttonReducer?.isButtonEnabled
 );

 const [holdBtnText, setHoldBtnText] = useState("Hold");
 const [holdOpen, setHoldOpen] = useState(false);
 const [withdrawOpen, setWithdrawOpen] = useState(false);
 const currentRoute = window.location.pathname;

 const initialValues = {
  energyRequirementType: isEditCase
   ? isOpen?.energyType?.genType
     ? isOpen?.energyType.genType
     : "ANY"
   : "",
  energyTypeId: isEditCase ? isOpen?.energyType?.id : "",
  startDate: isEditCase ? new Date(isOpen?.dateStartAt) : "",
  startTime: isEditCase ? isOpen?.slotStartAt : "",
  endDate: isEditCase ? new Date(isOpen?.dateEndAt) : "",
  endTime: isEditCase
   ? isOpen?.slotEndAt === "23:59"
     ? "24:00"
     : isOpen?.slotEndAt
   : "",
  landingCost: isEditCase ? isOpen?.landingCost : "",
  purchaseEnergy: isEditCase ? isOpen?.purchaseEnergy : "",
  pointOfDrawl: consumerDetails?.pod?.value ? consumerDetails.pod.value : "",
  voltageLevel:
   isEditCase && consumerDetails?.discomVoltage === null
    ? isOpen?.isStu
      ? consumerDetails?.company?.stuVoltageLevel
      : consumerDetails?.company?.istsVoltageLevel
    : consumerDetails?.discomVoltage,
  notifyFavouriteConsumers: isEditCase ? isOpen?.isNotifyFav : "",
  expiryDate: isEditCase ? isOpen?.bidEndAt && new Date(isOpen?.bidEndAt) : "",
  expiryTime: isEditCase
   ? isOpen?.bidEndAt && moment(isOpen?.bidEndAt).format("HH:mm")
   : "",
   podVal:
   isEditCase && consumerDetails?.discomVoltage === null
    ? isOpen?.isStu
      ? "stu"
      : "ists"
    : "",
 };

 useEffect(() => {
  getAllEnergyTypes()(dispatch);
  getConsumerDetails(myProfileDetails?.companyResponse?.consumer?.id)(dispatch);
 }, []);
 // useEffect(() => {
 //     if (allConCapacity.length > 0) {
 //         getMatchingProfilesCon(allConCapacity[0]?.id)
 //     }
 // }, [allConCapacity]);
 // const formatTime = (time) => {
 //     if (typeof time === 'string') {
 //         return moment(time, 'HH:mm').format('hh:mm A');
 //     }
 //     if (dayjs.isDayjs(time)) {
 //         return time.format("hh:mm A");
 //     }
 //     return '';
 // };
 const handleFormSubmit = (values) => {
  disableButton()(dispatch);
  // const formattedStartTime = formatTime(values.startTime);
  // const formattedEndTime = formatTime(values.endTime);
  // const formattedExpiryTime = formatTime(values.expiryTime);
  let startTime = values.startTime;
  let endTime = values.endTime;
  let expiryTime = values.expiryTime;
  if (typeof startTime !== "string") {
   startTime = dayjs(startTime).format("HH:mm");
  }
  if (typeof endTime !== "string") {
   endTime = dayjs(endTime).format("HH:mm");
  }
  if (typeof expiryTime !== "string") {
   expiryTime = dayjs(expiryTime).format("HH:mm");
  }

  let reqBody = {
   id: isEditCase ? isOpen.id && isOpen.id : null,
   name: isEditCase ? isOpen.name && isOpen.name : null,
   consumerId: myProfileDetails?.companyResponse?.consumer?.id,
   energyTypeId: values.energyTypeId ? +values.energyTypeId : null,
   dateStartAt: `${moment(values.startDate).format("DD-MMM-YYYY")}`,
   dateEndAt: `${moment(values.endDate).format("DD-MMM-yyyy")}`,
   slotStartAt: startTime,
   slotEndAt: endTime && endTime === "24:00" ? "23:59" : endTime,
   landingCost: values.landingCost,
   purchaseEnergy: values.purchaseEnergy,
   isNotifyFav: values.notifyFavouriteConsumers,
   bidEndAt: `${moment(values.expiryDate).format("DD-MMM-yyyy")} ${expiryTime}`,
   isStu: values.podVal === "stu",
   voltageLevel: values.voltageLevel,
  };
  if (isEditCase) {
   updateCapacityConsumer({ reqBody, handleSubmit, handleCapacityListing })(
    dispatch
   );
  } else {
   createCapacityConsumer({ reqBody, handleSubmit, handleCapacityListing })(
    dispatch
   );
  }
 };

 const validationSchema = Yup.object().shape({
  startDate: Yup.date().required("Required Field"),
  startTime: Yup.string().required("Required Field"),
  endDate: Yup.date().required("Required Field"),
  endTime: Yup.string().required("Required Field"),
  expiryDate: Yup.date().required("Required Field"),
  expiryTime: Yup.string().required("Required Field"),
  landingCost: Yup.number().test(
    'valueRange',
    `Value must be between 0 and 100 with 2 decimal places`,
    (value) => {
      if (value === undefined || value === null) {
        return true;
      }
      const decimal = String(value).split('.')[1];
      return value >= 0 && value <= 100 && (decimal?.length <= 2 || !decimal);
    }
  ).required("Required Field"),
  purchaseEnergy:  consumerDetails?.maxCapDrawl
  ? Yup.number()
     .required("Quantity is a required field")
     .test(
       'valueRange',
       `Value must be between 0 and ${consumerDetails?.maxCapDrawl} with 3 decimal places`,
       (value) => {
         if (value === undefined || value === null) {
           return true;
         }
         const decimal = String(value).split('.')[1];
         return value >= 0 && value <= consumerDetails?.maxCapDrawl && (decimal?.length <= 3 || !decimal);
       }
     ).max(
      consumerDetails?.maxCapDrawl,
      "Quantity must be less than or equal to the Maximum Capacity of Drawal given during signup"
     )
  : Yup.number()
  .test(
    'valueRange',
    'Value must be between 0 and 10,000 with 3 decimal places',
    (value) => {
      if (value === undefined || value === null) {
        return true;
      }
      const decimal = String(value).split('.')[1];
      return value >= 0 && value <= 10000 && (decimal?.length <= 3 || !decimal);
    }
  ).required("Quantity is a required field"),
  energyRequirementType: Yup.string().required("Required field"),
  podVal:
   consumerDetails?.discomVoltage === null
    ? Yup.string().required("Select Point Of Drawal")
    : Yup.string().notRequired(),
 });
 const handleHold = () => {
  setHoldOpen(true);
 };

 const handleHoldClose = () => {
  disableButton()(dispatch);
  const data = {
   id: isOpen?.id,
   status: isOpen?.status === "HOLD" ? "ACTIVE" : "HOLD",
  };
  capacityConsumerService
   .updateCapacityStatus(data)
   .then((response) => {
    if (response?.data?.code === 200) {
     setHoldOpen(false);
     handleSubmit();
     handleCapacityListing("CapacityListing");
     enableButton()(dispatch);
     toast.success("Status updated successfully", toastProperties);
    }
   })
   .catch((error) => {
    console.error("Api call Error :", error);
    enableButton()(dispatch);
   });
 };
 const handleCloseNo = () => {
  setHoldOpen(false);
 };

 const handleWithdraw = () => {
  setWithdrawOpen(true);
 };
 const handleWithdrawClose = () => {
  disableButton()(dispatch);
  const data = {
   id: isOpen?.id,
   status: "WITHDRAWN",
  };
  capacityConsumerService
   .updateCapacityStatus(data)
   .then((response) => {
    if (response?.data?.code === 200) {
     setWithdrawOpen(false);
     handleSubmit();
     handleCapacityListing("CapacityListing");
     enableButton()(dispatch);
     toast.success(
      "This capacity has been withdrawn successfully",
      toastProperties
     );
    }
   })
   .catch((error) => {
    console.error("Api call Error :", error);
    enableButton()(dispatch);
   });
 };
 const handleWithdrawCloseNo = () => {
  setWithdrawOpen(false);
 };
 const numberInputOnWheelPreventChange = (e) => {
  // Prevent the input value change
  e.target.blur();

  // Prevent the page/container scrolling
  e.stopPropagation();

  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
   e.target.focus();
  }, 0);
 };
 return (
  <Modal
   show={Boolean(isOpen)}
   onHide={() => handleSubmit("")}
   className="modal"
   size="xl"
  >
   <Modal.Header closeButton>
    <Modal.Title>
     {isEditCase ? "Edit" : "Add"}
     {" Listing"}
    </Modal.Title>
   </Modal.Header>
   <div className="container-fluid">
    <div className="row m-4">
     <div className="col-md-12">
      <div>
       <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmit}
        validateOnMount={false}
        validate={(values) => {
          const errors = {};
          const currentDateTime = new Date();
          const maxStartTime = addHours(currentDateTime, 3);
          let selectedStartTime = values.startTime;
          const minExpiryTime = addHours(currentDateTime, 1);
          let selectedTExpiryTime = values.expiryTime;
          if (typeof selectedTExpiryTime === "string") {
           selectedTExpiryTime = dayjs(new Date())
            .set("hour", parseInt(selectedTExpiryTime.split(":")[0]))
            .set("minute", parseInt(selectedTExpiryTime.split(":")[1]));
          }
          if (typeof selectedStartTime === "string") {
           selectedStartTime = dayjs(new Date())
            .set("hour", parseInt(selectedStartTime.split(":")[0]))
            .set("minute", parseInt(selectedStartTime.split(":")[1]));
          }
          if (
           values.energyRequirementType !== "ANY" &&
           (values.energyTypeId === "" || values.energyTypeId === undefined)
          ) {
           errors.energyTypeId = "Required Field";
          }
          let startTimeValue = values.startTime;
          let endTimeValue = values.endTime;
          if (typeof startTimeValue === "string") {
           startTimeValue = dayjs(new Date())
            .set("hour", parseInt(startTimeValue.split(":")[0]))
            .set("minute", parseInt(startTimeValue.split(":")[1]));
          }
          if (typeof endTimeValue === "string") {
           endTimeValue = dayjs(new Date())
            .set("hour", parseInt(endTimeValue.split(":")[0]))
            .set("minute", parseInt(endTimeValue.split(":")[1]));
          }
          const minEndTime = startTimeValue.add(15, "minute"); 
 
          if (endTimeValue.isBefore(minEndTime)) {
           errors.endTime =
            "End time must be at least 15 minutes after start time.";
          }
          
          const validateTime = (time, field) => {
             if (time) {
               const timeSplit = time.split(':');
               const minutesArr = ['00', '15', '30', '45'];
               if (!minutesArr.includes(timeSplit[1])) {
                 errors[field] = "Time should be in 15-minute intervals only";
               }
             }
           };
           
           validateTime(values?.startTime, 'startTime');
           validateTime(values?.endTime, 'endTime');
           validateTime(values?.expiryTime, 'expiryTime');
           
          if (
           values.startDate &&
           values.startDate.toDateString() === currentDateTime.toDateString() &&
           selectedStartTime.isBefore(maxStartTime)
          ) {
           errors.startTime =
            "Start time must be at least 3 hours from the current time.";
          }
          if (
           !isEditCase &&
           values.expiryDate &&
           values.expiryDate.toDateString() === currentDateTime.toDateString() &&
           selectedTExpiryTime.isBefore(minExpiryTime)
          ) {
           errors.expiryTime =
            "Expiry time must be at least 1 hour from the current time.";
          }
          if (
           values.startDate &&
           values.startDate instanceof Date &&
           values.startTime &&
           values.expiryDate &&
           values.expiryTime
          ) {
           const startDateTime = moment(
            `${moment(values.startDate).format("DD-MMM-YYYY")} ${values.startTime}`,
            "DD-MMM-YYYY HH:mm"
           );
 
           const expiryDateTime = moment(
            `${moment(values.expiryDate).format("DD-MMM-YYYY")} ${values.expiryTime}`,
            "DD-MMM-YYYY HH:mm"
           );
 
           const minExpiryDateTime = moment(startDateTime).subtract(2, "hours");
           if (expiryDateTime.isAfter(minExpiryDateTime)) {
            errors.expiryTime =
             "Expiry date and time must be at least 2 hours before the start date and time.";
           }
          }
          return errors;
         }}
       >
        {({
         isSubmitting,
         setFieldTouched,
         setFieldValue,
         values,
         handleBlur,
         errors,
        }) => {
         let startTimeValue = values.startTime;
         if (typeof startTimeValue == "string") {
          startTimeValue = dayjs(new Date())
           .set("hour", parseInt(startTimeValue.split(":")[0]))
           .set("minute", parseInt(startTimeValue.split(":")[1]));
         }
         return (
          <Form>
           <div className="row justify-contnet-center align-items-center">
            <div className="col-md-12">
             <div className="">
              <div className="row mb-3">
               <div className="col-md-6">
                <div className="mb-3 fw-medium">Energy Requirement Type*</div>
                <div className="d-flex gap-3">
                 <div className="form-check-flex">
                  <Field
                   className="form-check-input"
                   type="radio"
                   name="energyRequirementType"
                   value="RENEWABLE"
                   id="energyRequirementType1"
                   checked={"RENEWABLE" == values.energyRequirementType}
                   onBlur={() => setFieldValue("energyTypeId", "")}
                  />
                  <label
                   className="form-check-label"
                   htmlFor="energyRequirementType1"
                  >
                   Renewable
                  </label>
                 </div>
                 <div className="form-check-flex">
                  <Field
                   className="form-check-input"
                   type="radio"
                   name="energyRequirementType"
                   value="NON_RENEWABLE"
                   id="energyRequirementType2"
                   checked={"NON_RENEWABLE" == values.energyRequirementType}
                   onClick={() => setFieldValue("energyTypeId", "")}
                  />
                  <label
                   className="form-check-label"
                   htmlFor="energyRequirementType2"
                  >
                   Non-Renewable
                  </label>
                 </div>
                 <div className="form-check-flex">
                  <Field
                   className="form-check-input"
                   type="radio"
                   name="energyRequirementType"
                   value="ANY"
                   id="energyRequirementType3"
                   checked={"ANY" == values.energyRequirementType}
                   onClick={() => setFieldValue("energyTypeId", "")}
                  />
                  <label
                   className="form-check-label"
                   htmlFor="energyRequirementType3"
                  >
                   Any
                  </label>
                 </div>
                </div>
                <ErrorMessage
                 name="energyRequirementType"
                 className="text-danger"
                 component="div"
                />
               </div>
               {values.energyRequirementType != "ANY" && (
                <div className="col-md-6">
                 <Field
                  as="select"
                  name="energyTypeId"
                  id="energyTypeId"
                  className="custom-input"
                 >
                  <option value="">Energy Type*</option>
                  {energyTypes
                   ?.filter((ite) => {
                    return values.energyRequirementType == "RENEWABLE"
                     ? ite?.genType == "RENEWABLE"
                     : values.energyRequirementType == "NON_RENEWABLE"
                     ? ite?.genType == "NON_RENEWABLE"
                     : "";
                   })
                   .map((item) => (
                    <option key={item?.id} value={item?.id}>
                     {item?.type}
                    </option>
                   ))}
                 </Field>
                 <ErrorMessage
                  name="energyTypeId"
                  component="div"
                  className="text-danger"
                 />
                </div>
               )}
              </div>
              <div className="row mb-3">
               <div className="col-md-6">
                {/* <div>Capacity Start Date/Time</div> */}
                <div className="row">
                 <div className="col-md-6 mb-2 mb-md-0">
                  <label>Start Date</label>
                  <DatePicker
                   className="custom-input w-100"
                   name="startDate"
                   selected={values.startDate}
                   onChange={(date) => setFieldValue("startDate", date)}
                   minDate={isEditCase ? values.expiryDate : moment().toDate()}
                   onBlur={handleBlur("startDate")}
                   dateFormat="dd-MMM-yyyy"
                   placeholderText="Date*"
                   autoComplete="off"
                   showYearDropdown
                   showMonthDropdown
                   scrollableMonthYearDropdown
                  />
                  <ErrorMessage
                   name="startDate"
                   component="div"
                   className="text-danger"
                  />
                 </div>
                 <div className="col-md-6 mb-2 mb-md-0">
                  <label>End Date</label>
                  <DatePicker
                   className="custom-input w-100"
                   name="endDate"
                   selected={values.endDate}
                   onChange={(date) => setFieldValue("endDate", date)}
                   minDate={
                    values.startDate ? values.startDate : moment().toDate()
                   }
                   onBlur={handleBlur("endDate")}
                   dateFormat="dd-MMM-yyyy"
                   placeholderText="Date*"
                   autoComplete="off"
                   showYearDropdown
                   showMonthDropdown
                   scrollableMonthYearDropdown
                  />
                  <ErrorMessage
                   name="endDate"
                   component="div"
                   className="text-danger"
                  />
                 </div>
                </div>
               </div>
               <div className="col-md-6">
                {/* <div>Capacity End Date/Time</div> */}
                <div className="row">
                 <div className="col-md-6 mb-2 mb-md-0">
                  <label>
                   Start Time &nbsp;
                   <OverlayTrigger
                    placement="right"
                    overlay={
                     <Tooltip>
                      Start time must be at least 3 hours from the current time.
                     </Tooltip>
                    }
                   >
                    <i
                     className="bi bi-info-circle"
                     style={{ color: "#4169e1" }}
                    ></i>
                   </OverlayTrigger>
                  </label>
                  <CustomTimePicker
                   minutesStep={15}
                   updateTimeToParent={(timeText) => {
                    setFieldValue("startTime", timeText);
                   }}
                   time={values.startTime}
                   maxHours={24}
                   hasInititalValues={isEditCase}
                  />
                  <ErrorMessage
                   name="startTime"
                   component="div"
                   className="text-danger"
                  />
                 </div>
                 <div className="col-md-6 mb-2 mb-md-0">
                  <label>End Time</label>
                  <CustomTimePicker
                   minutesStep={15}
                   updateTimeToParent={(timeText) => {
                    setFieldValue("endTime", timeText);
                   }}
                   time={values.endTime}
                   minTime={values.startTime}
                   minTimeDiffInMinutes={15}
                   maxHours={25}
                   hasInititalValues={isEditCase}
                  />
                  <ErrorMessage
                   name="endTime"
                   component="div"
                   className="text-danger"
                  />
                 </div>
                </div>
               </div>
              </div>

              <hr className="horizontal-line" />
              <div className="row mt-3">
               <div className="col-md-6 mb-2 mb-md-0 position-relative">
                <label htmlFor="landingCost" className="postion-label-dynamic">
                 Consumer Landed Cost (₹ per Unit)*
                </label>
                <Field
                 type="number"
                 onWheel={numberInputOnWheelPreventChange}
                 className="custom-input no-spinner"
                 placeholder=""
                 name="landingCost"
                 onKeyDown={(e) => {
                    if (
                     e.key === "-" ||
                     e.key === "+" ||
                     e.key === "e" ||
                     e.key === "ArrowUp" ||
                     e.key === "ArrowDown"
                    ) {
                     e.preventDefault();
                    }
                   }}
                />
                <ErrorMessage
                 name="landingCost"
                 component="div"
                 className="text-danger"
                />
               </div>
               <div className="col-md-6 mb-1 mb-md-0 position-relative">
                <label
                 htmlFor="purchaseEnergy"
                 className="postion-label-dynamic"
                >
                 Energy to be Purchased (MW)*
                </label>
                <Field
                 type="number"
                 onWheel={numberInputOnWheelPreventChange}
                 className="custom-input no-spinner"
                 placeholder=""
                 name="purchaseEnergy"
                 onKeyDown={(e) => {
                    if (
                     e.key === "-" ||
                     e.key === "+" ||
                     e.key === "e" ||
                     e.key === "ArrowUp" ||
                     e.key === "ArrowDown"
                    ) {
                     e.preventDefault();
                    }
                   }}                />
                <ErrorMessage
                 name="purchaseEnergy"
                 component="div"
                 className="text-danger"
                />
               </div>
              </div>
              <div className="row mt-3">
               <div className="col-md-6 mb-2 mb-md-0 position-relative">
               {consumerDetails?.discomVoltage === null ? (
                 <>
                  <div className="mb-3 fw-medium">Point of Drawal*</div>
                  <div className="d-flex gap-3">
                   <div className="form-check-flex">
                    <Field
                     className="form-check-input"
                     type="radio"
                     name="podVal"
                     value="ists"
                     id="poiVal1"
                     checked={"ists" == values.podVal}
                     onClick={() =>
                      setFieldValue(
                       "voltageLevel",
                       consumerDetails?.company?.istsVoltageLevel
                      )
                     }
                    />
                    <label className="form-check-label" htmlFor="poiVal1">
                     ISTS
                    </label>
                   </div>
                   <div className="form-check-flex">
                    <Field
                     className="form-check-input"
                     type="radio"
                     name="podVal"
                     value="stu"
                     id="poiVal2"
                     checked={"stu" == values.podVal}
                     onClick={() =>
                      setFieldValue(
                       "voltageLevel",
                       consumerDetails?.company?.stuVoltageLevel
                      )
                     }
                    />
                    <label className="form-check-label" htmlFor="poiVal2">
                     STU
                    </label>
                   </div>
                  </div>
                  <ErrorMessage
                   name="podVal"
                   className="text-danger"
                   component="div"
                  />
                 </>
                ) : (
                 <>
                  <label
                   htmlFor="pointOfDrawl"
                   className="postion-label-dynamic"
                  >
                   Point of Drawal
                  </label>
                  <Field
                   type="text"
                   className="custom-input"
                   placeholder="STU"
                   name="pointOfDrawl"
                   disabled
                  />
                 </>
                )}
               </div>
               <div className="col-md-6 mb-2 mb-md-0 position-relative">
                <label htmlFor="voltageLevel" className="postion-label-dynamic">
                 Voltage Level (KV)
                </label>
                <Field
                 type="text"
                 className="custom-input"
                 placeholder="NA"
                 name="voltageLevel"
                 disabled
                />
<ErrorMessage
                   name="podVal"
                   className="text-danger"
                   component="div"
                  />               </div>
              </div>
              <hr className="horizontal-line mt-3" />
              <div className="row mt-3">
               <div className="col-md-6">
                <div>
                 Expiry Date/Time &nbsp;
                 <OverlayTrigger
                  placement="right"
                  overlay={
                   <Tooltip>
                    Expiry date and time must be at least 2 hours before the
                    start date and time.
                   </Tooltip>
                  }
                 >
                  <i
                   className="bi bi-info-circle "
                   style={{ color: "#4169e1" }}
                  ></i>
                 </OverlayTrigger>
                </div>
                <div className="row">
                 <div className="col-md-6 mb-2 mb-md-0">
                  <DatePicker
                   className="custom-input w-100"
                   name="expiryDate"
                   selected={values.expiryDate}
                   onChange={(date) => setFieldValue("expiryDate", date)}
                   minDate={moment().toDate()}
                   onBlur={handleBlur("expiryDate")}
                   dateFormat="dd-MMM-yyyy"
                   placeholderText="Date*"
                   autoComplete="off"
                   showYearDropdown
                   showMonthDropdown
                   scrollableMonthYearDropdown
                   disabled={isEditCase ? true : false}
                  />
                  <ErrorMessage
                   name="expiryDate"
                   component="div"
                   className="text-danger"
                  />
                 </div>
                 <div className="col-md-6 mb-2 mb-md-0">
                  <CustomTimePicker
                   minutesStep={15}
                   updateTimeToParent={(timeText) => {
                    setFieldValue("expiryTime", timeText);
                   }}
                   time={values.expiryTime}
                   readOnly={isEditCase}
                   maxHours={24}
                   hasInititalValues={isEditCase}
                  />
                  <ErrorMessage
                   name="expiryTime"
                   component="div"
                   className="text-danger"
                  />
                 </div>
                </div>
               </div>
              </div>
              <small>
               *Expiry date/time cannot be edited once the capacity is created
              </small>
              {/* <div className="row mt-4">
                                                            <div className="col-md-12">
                                                                <Field
                                                                    type="checkbox"
                                                                    className="csutom-checkbox"
                                                                    name="notifyFavouriteConsumers"
                                                                />
                                                                <label
                                                                    htmlFor="notifyFavouriteConsumers"
                                                                    className="ps-2"
                                                                >
                                                                    Notify Favourite Generators
                                                                </label>
                                                            </div>
                                                        </div> */}
              <hr className="horizontal-line my-4" />
              <div className="button-alignment-class">
               <div className="button-alignment-class-end">
                <button
                 type="submit"
                 className="btn btn-signup btn btn-primary"
                 disabled={isButtonEnabled}
                >
                 {isEditCase ? "Update" : "Submit"}
                </button>
               </div>
               {isEditCase && (
                <div style={{ display: "flex", gap: "10px" }}>
                 {/* <button className='btn btn-login' type='button' onClick={handleHold}>{holdBtnText}</button>
                                                                    {holdOpen && <CustomConfirmBox
                                                                        title={holdBtnText}
                                                                        message={`Do you want to ${holdBtnText == "Release" ? 'Release' : 'Hold'} the Capacity?`}
                                                                        open={holdOpen}
                                                                        handleClose={handleHoldClose}
                                                                        handleCloseNo={handleCloseNo}
                                                                    />} */}
                 <button
                  className="btn btn-login"
                  type="button"
                  disabled={isButtonEnabled}
                  onClick={handleHold}
                 >
                  {isOpen?.status === "HOLD" ? "Release" : "Hold"}
                 </button>
                 {holdOpen && (
                  <CustomConfirmBox
                   title={isOpen?.status === "HOLD" ? "Release" : "Hold"}
                   message={`Do you want to ${
                    isOpen?.status === "HOLD" ? "Release" : "Hold"
                   } the Capacity?`}
                   open={holdOpen}
                   handleClose={handleHoldClose}
                   handleCloseNo={handleCloseNo}
                  />
                 )}
                 <button
                  className="btn btn-withdrawal"
                  type="button"
                  disabled={isButtonEnabled}
                  onClick={handleWithdraw}
                 >
                  Withdraw
                 </button>
                 {withdrawOpen && (
                  <CustomConfirmBox
                   title="Withdraw"
                   message="Do you want to withdraw the Capacity?"
                   open={withdrawOpen}
                   handleClose={handleWithdrawClose}
                   handleCloseNo={handleWithdrawCloseNo}
                  />
                 )}
                </div>
               )}
              </div>
             </div>
            </div>
           </div>
          </Form>
         );
        }}
       </Formik>
      </div>
     </div>
    </div>
   </div>
  </Modal>
 );
};
